import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  closeButton: {
    position: 'absolute',
    right: "8px",
    top: "8px",
    color: capitalDesignTokens.semanticColors.foreground.secondary,
  },

  descriptionText: {
    marginBottom: "24px",
    color: capitalDesignTokens.semanticColors.foreground.secondary,
  },

  visibilityLabel: {
    marginBottom: '4px',
  },

  warningContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: "8px",
    padding: "12px",
    backgroundColor: "#fff3cd",
    borderRadius: "4px",
    marginTop: "16px",
  },

  warningIcon: {
    color: "#856404",
    fontSize: "16px",
  },

  warningText: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: "#856404",
  },

  dialogActions: {
    padding: "16px",
    gap: "8px",
  },

  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },

  followFormControl: {
    marginTop: "24px",
    marginLeft: "4px",
    justifyContent: 'space-between',
  },

  switchInputProps: {
    className: 'no-format',
    style: { display: 'none' },
  },
  disclaimerContainer:{
    marginTop:"8px",
    padding:"8px 8px 8px 16px",
    borderRadius:"4px",
    border:`1px solid ${capitalDesignTokens.foundations.colors.yellow400}`,
    backgroundColor:capitalDesignTokens.foundations.colors.yellow50,

  },
  disclaimerText:{
    fontSize:capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    fontWeight:capitalDesignTokens.foundations.typography.fontWeight.normal,
    lineHeight:"20px",
    display:"inline"
  },
  disclaimerBox:{
    display:"flex",
    alignItems:"flex-start",
    gap:"8px",
    "& .MuiSvgIcon-root":{
      fontSize:"16px",
      color:capitalDesignTokens.foundations.colors.yellow700
    },
  },
  termsAndConditions:{
    marginLeft:"4px",
    cursor:"pointer",
    "a":{
      color:capitalDesignTokens.foundations.colors.brand800,
      textDecoration:"underline",
      
    }
  }
});
